export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const APP_NAME = 'Maghaweer.AI';

export const COLORS = {
  primary: '#1a1a2e',
  secondary: '#16213e',
  accent: '#0f3460',
  highlight: '#e94560',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
};

export const SIDEBAR_SECTIONS = [
  { key: 'dashboard', label: 'Dashboard', icon: 'MdDashboard', path: '/' },
  {
    key: 'hf',
    label: 'HF Analytics',
    icon: 'MdShowChart',
    children: [
      { label: 'Overview', path: '/hf' },
      { label: 'Fund Detail', path: '/hf/fund-detail' },
      { label: 'Comparison', path: '/hf/comparison' },
      { label: 'Correlation', path: '/hf/correlation' },
      { label: 'Drawdown', path: '/hf/drawdown' },
      { label: 'Rolling', path: '/hf/rolling' },
      { label: 'Calendar', path: '/hf/calendar' },
    ],
  },
  {
    key: 'saa',
    label: 'Asset Allocation',
    icon: 'MdPieChart',
    children: [
      { label: 'Allocation', path: '/saa' },
      { label: 'Returns', path: '/saa/returns' },
      { label: 'Risk', path: '/saa/risk' },
      { label: 'Frontier', path: '/saa/frontier' },
      { label: 'Data', path: '/saa/data' },
    ],
  },
  {
    key: 'market',
    label: 'Market Tracker',
    icon: 'MdNewspaper',
    disabled: true,
    children: [],
  },
  {
    key: 'trading',
    label: 'Trading',
    icon: 'MdBolt',
    disabled: true,
    children: [],
  },
];
